import axios from "axios";
// import getters from '@/store/getters'

var base = "https://main-api.southsudanminingjournal.co/api/v1/auth/";

// baseURL: process.env.VUE_APP_API,
const instance = axios.create({
  baseURL: base,
});

export default instance;
